module.exports = __webpack_public_path__ + "static/media/portada.98516aba.jpg";